import React, { Fragment } from "react";

import IpAuthenticationCell from "./IpAuthenticationCell";
import RegionAuthenticationCell from "./RegionAuthenticationCell";
import RefererAuthenticationCell from "./RefererAuthenticationCell";
import EzProxyAuthenticationCell from "./EzProxyAuthenticationCell";
import SipAuthenticationCell from "./SipAuthenticationCell";
import PapiAuthenticationCell from "./PapiAuthenticationCell";
import BarcodeAuthenticationCell from "./BarcodeAuthenticationCell";
import ShibbolethAuthenticationCell from "./ShibbolethAuthenticationCell";

const AuthenticationDetailsCell = props => {
  const { authentication } = props;

  return (
    <Fragment>
      {authentication.type === "ip" ? (
        <IpAuthenticationCell authentication={authentication} />
      ) : authentication.type === "region" ? (
        <RegionAuthenticationCell authentication={authentication} />
      ) : authentication.type === "referer" ? (
        <RefererAuthenticationCell authentication={authentication} />
      ) : authentication.type === "ezproxy" ? (
        <EzProxyAuthenticationCell authentication={authentication} />
      ) : authentication.type === "shibboleth" ? (
        <ShibbolethAuthenticationCell authentication={authentication} />
      ) : authentication.type === "sip" ? (
        <SipAuthenticationCell authentication={authentication} />
      ) : authentication.type === "papi" ? (
        <PapiAuthenticationCell authentication={authentication} />
      ) : authentication.type === "barcode" ? (
        <BarcodeAuthenticationCell authentication={authentication} />
      ) : (
        <div></div>
      )}
    </Fragment>
  );
};

export default AuthenticationDetailsCell;
